export const GET_IDO_LIST = 'GET_IDO_LIST';
export const GET_IDO_LIST_SUCCESS = 'GET_IDO_LIST_SUCCESS';
export const GET_IDO_LIST_FAILURE = 'GET_IDO_LIST_FAILURE';
